module.exports = __webpack_public_path__ + "static/media/hero.99aa3cf3.jpg";